import { render, staticRenderFns } from "./algorithmicCalculation.vue?vue&type=template&id=7d1b169c&scoped=true"
import script from "./algorithmicCalculation.vue?vue&type=script&lang=js"
export * from "./algorithmicCalculation.vue?vue&type=script&lang=js"
import style0 from "./algorithmicCalculation.vue?vue&type=style&index=0&id=7d1b169c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b169c",
  null
  
)

export default component.exports